import React, { Component } from "react";
import Axios from "axios";
import "./PlotDentOnImage.css";
import { configuration } from "../../appConfig";
import Swal from "sweetalert2";
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

export default class PlotDentOnImage extends Component {
  state = {
    dents: [],
    zoomLevel: 25,
    division: 2,
    checked: true,
    dentCount: 0,
    dentColor: "yellow",
    dentSize: "A",
    notes: "",
    dentPositions: [],
    data: {},
    partData: {},
    A: 0,
    B: 0,
    C: 0,
    AddedCount: 0,
    RemovedCount: 0,
    Modified: false,
  };

  jsonApi = () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    Axios.get(
      `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
    ).then((r) => {
      if (r.data) {
        const dentPos =
          r.data.Dents &&
          r.data.Dents.length &&
          r.data.Dents.filter((r) => r.Part == this.props.part)[0].DentPos;
        const partData =
          r.data.Dents &&
          r.data.Dents.length &&
          r.data.Dents.filter((r) => r.Part == this.props.part)[0];
        this.setState({
          data: r.data,
          dentPositions: dentPos,
          partData,
          A: partData && partData.A,
          B: partData && partData.B,
          C: partData && partData.C,
          AddedCount: partData && partData.AddedCount,
          RemovedCount: partData && partData.RemovedCount,
          Modified: partData && partData.Modified,
        });
        // console.table(partData);
        //   console.table(r.data.Dents);
        //   console.table(dentPos);
      }
    });
  };

  getData = async () => {
    const response = await Axios.get(
      configuration.getExtraImageDents +
        "?part=" +
        this.props.part.split(".")[0] +
        "&vin=" +
        this.props.vin +
        "&partnerId=" +
        this.props.partnerId
    );

    //driveandscan.de/scanImages/001-sandip/WAUZZZ8X7EB166057/501406923.json

    if (response.data) {
      const str = await response.data.json;
      if (str) {
        const data = JSON.parse(str);

        this.setState({
          dents: data.dents,
          notes: data.notes,
        });
      }
    }
  };
  click = (el) => {
    if (this.props.controls) {
      // let size = window.prompt(
      //   "Provide Circle Diameter for " + this.state.dentSize
      // );
      // if (!size) return;
      //alert(size);

      let dentSize = { A: 20, B: 40, C: 90 };
      const client = localStorage.getItem("client");
      if(client=="DNS"){
dentSize.A=40
      }
      let size = dentSize[this.state.dentSize];
      const elm = el.target;
      const cord = elm.getBoundingClientRect();
      size = parseInt(size);
      var colors = {
        A: "Red",
        B: "Yellow",
        C: "Green",
      };

      const radius = size / 2;

      const x = (el.pageX * 100) / this.state.zoomLevel - cord.left - radius;
      const y = (el.pageY * 100) / this.state.zoomLevel - cord.top - radius;
      //const x = (el.pageX * 100) / this.state.zoomLevel;
      //const y = (el.pageY * 100) / this.state.zoomLevel;
      //var xx = x;
      // var yy = y;

      // const result = this.average(this.state.dents) || 20;

      if (this.state.checked) {
        this.setState(
          (state) => {
            const list = state.dentPositions.concat([
              {
                No: this.state.dentCount,
                ErrorCode: 1000,
                X: x,
                Y: y,
                DiaPx: size,
                ABC: this.state.dentSize,
                Color: colors[this.state.dentSize],
                DiaMm: 67.71,
                Group: 0,
              },
            ]);

            return {
              dentPositions: list,
              dentCount: state.dentCount + 1,
              [this.state.dentSize]: this.state[this.state.dentSize] + 1,
              AddedCount: state.AddedCount + 1,
            };
          },
          () => {
          }
        );
      }
    }
  };
  serverUploadFormat = () => {
    // const payload = this.state.dents.map((res, index) => {
    //   const dd = res.split(" ");
    //   return `${index} ${dd[1]} ${dd[2]} ${dd[3]} 1`;
    // });
    // const str = payload.toString().replace(/,/g, "++++");

    const { A, B, C, RemovedCount, AddedCount } = this.state;
    let data = this.state.data;
    let dentPositions = this.state.dentPositions;
    let result = data.Dents.filter((t) => {
      if (t.Part == this.props.part) {
        t.A = A;
        t.B = B;
        t.C = C;
        t.AddedCount = AddedCount;
        t.RemovedCount = RemovedCount;
        t.DentPos = dentPositions;
        t.Modified = true;
        t.TotalDents = t.TotalDents;
      }
    });

    //this.props.saveChanges(str);
    this.saveChanges(this.state.data);
    //  // return str
  };
  saveChanges = (payload) => {
    const url =
      configuration.PostEditorChanges +
      `?partnerId=${this.props.partnerId}&vin=${this.props.vin}&dents=${this.state.dentCount}`;

    Axios.post(url, payload).then((res) => {
      Toast.fire({
        type: "success",
        title: "Data saved successfully",
      });
    });

  };
  average = (arr) => {
    if (arr.length) {
      return (
        arr.reduce((p, c) => {
          let arrp = [];
          if (p.length > 5) {
            arrp = p.split(" ");
          } else {
            arrp[3] = p;
          }
          const arrc = c.split(" ");
          return parseInt(arrp[3]) + parseInt(arrc[3]);
        }) / arr.length
      );
    } else {
      return 20;
    }
  };

  componentDidMount() {
    //  this.getData();
    // alert(this.props.zoom)
    this.jsonApi();
  }
  remove = (i, dentType) => {
    if (this.props.controls) {
      this.setState(
        (state) => {
          //...state.dents,
          const list = state.dentPositions.filter((row, index) => {
            return index !== i;
          });
          //  const list = state.dents.concat(`78 ${el.pageX} ${el.pageY} 21.136816 1`);
          return {
            dentPositions: list,
            dentCount: state.dentCount - 1,
            [dentType]: this.state[dentType] - 1,
            RemovedCount: state.RemovedCount + 1,
          };
        },
        () => {
          // this.serverUploadFormat();
        }
      );
    }
  };
  zoom = (zoom) => {
    if (zoom === "--") {
      this.state.zoomLevel > 20 &&
        this.setState({
          zoomLevel: this.state.zoomLevel - 10,
          division: this.state.division + 2,
        });
    } else {
      this.setState({
        zoomLevel: this.state.zoomLevel + 10,
        division: this.state.division - 2,
      });
    }
    if (zoom === "reset") {
      this.setState({ zoomLevel: 30, division: 2 });
    }
  };

  onchange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  replaceImage = (error) => {
    let defaultImage = require('../../assets/img/brand/default-image.png')
    error.target.src = defaultImage; 
  }

  render() {
    const {
      dents,
      dentCount,
      dentPositions,
      AddedCount,
      RemovedCount,
      Modified,
    } = this.state;
    const client = localStorage.getItem('client')
    
    if(this.props.showDents === false){
      // Remove dents for ReportFullDNS 
      return <img
                alt=""
                src={`${configuration.imagePath}/scanImages/${this.props.partnerId}/${this.props.vin}/Report_${this.props.part}_1.jpg`}
                className="editor-image"
                onError={this.replaceImage}
                // onClick={this.click}
              />
    } else if (Modified && Modified=="true") {
      return (
        <div>
          <div
            className="row controls-bar mb-2"
            style={{ display: this.props.controls ? "" : "none" }}
          >
            {client !== "DNS" && (
              <select
                name="dentSize"
                onChange={this.onchange}
                className="form-control col-2 mr-2 dropdown"
              >
                <option value="A">A : SMALL</option>
                <option value="B">B : MEDIUM</option>
                <option value="C">C : BIG</option>
              </select>
            )}
            <button
              className="btn btn-success ml-2 mr-2"
              onClick={() => this.zoom("--")}
            >
              <i className="fa fa-search-minus"></i>
            </button>
            {/* <button onClick={() => this.zoom("reset")}>Reset</button> */}
            <button
              className="btn btn-success mr-2"
              onClick={() => this.zoom("++")}
            >
              <i className="fa fa-search-plus" aria-hidden="true"></i>
            </button>
            {/* <input
            className=" col-7 form-control "
            onChange={(e) => this.setState({ notes: e.target.value })}
            type="text"
            placeholder="Notes"
            width="100%"
            value={this.state.notes}
          /> */}
            <button
              onClick={this.serverUploadFormat}
              className="btn btn-success"
            >
              Save
            </button>
            &nbsp; &nbsp;
            <span className="text-center  h4">
              Total Dents : {dentPositions.length} , AddedCount:
              {AddedCount} , RemovedCount : {RemovedCount}
            </span>
          </div>
          <div id="canvas">
            <div id="editorCanvas">
              {/* {Modified ? "true" : "false"} */}
              <img
                alt=""
                src={`${configuration.imagePath}/scanImages/${this.props.partnerId}/${this.props.vin}/Report_${this.props.part}_1.jpg`}
                style={{
                  zoom: this.state.zoomLevel + "%",
                }}
                className="editor-image"
                onClick={this.click}
              />
              {/* <img
              alt=""
              className="editor-image"
              src={`${configuration.imagePath}/scanImages/${this.props.partnerId}/${this.props.vin}/${this.props.part}_1.jpg`}
              zoom="20"
            /> */}
              {dentPositions.map((row, i) => {

                const size = row.DiaPx;
                const x = row.X;
                const y = row.Y;
                return (
                  <div
                    onClick={() => this.remove(i, row.ABC)}
                    key={i}
                    style={{
                      height: parseInt(size),
                      width: parseInt(size),
                      border: `5px solid ${row.Color}`,
                      top: `${y}px`,
                      left: `${x}px`,
                      zoom: this.state.zoomLevel + "%",
                    }}
                    className="dent-spot"
                  >
                    {/* <span className="textgd">({i})</span> */}
                    {/* <button className="deleteBtn">X</button> */}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <img
          alt=""
          style={{height:this.props.part === 'Underbody' ? 'auto':''}} //bcoz underbody part has only one img 
          className="partImage"
          src={`${configuration.imagePath}/scanImages/${this.props.partnerId}/${this.props.vin}/Report_${this.props.part}_1.jpg`}
          zoom="20"
          onError={(img_comp) =>
            (img_comp.target.src = require("../../assets/img/brand/default-image.png"))
          }
        />
      );
    }


  }
}
